import { render, staticRenderFns } from "./FreeAllocation.vue?vue&type=template&id=2c5009d0&scoped=true&"
import script from "./FreeAllocation.vue?vue&type=script&lang=js&"
export * from "./FreeAllocation.vue?vue&type=script&lang=js&"
import style0 from "./FreeAllocation.vue?vue&type=style&index=0&id=2c5009d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5009d0",
  null
  
)

export default component.exports